<div class="row mt-2 no-gutters">
  <div class="col">
    <small *ngIf="accountCategory== 'RENTAL_FLEET'"><a [routerLink]="['/rental-fleet']" class="text-secondary">Admin
        Console</a>&nbsp;/<a class="text-secondary">&nbsp;Dashboard</a></small>
    <small *ngIf="accountCategory== 'FLEET_MANAGEMENT_COMPANY' || accountCategory == 'MOBILITY_COMPANY' || accountCategory == 'FIELD_SERVICE_COMPANY'"><a [routerLink]="['/commercial-fleet']"
        class="text-secondary">Admin Console</a>&nbsp;/<a class="text-secondary">&nbsp;Dashboard</a></small>
  </div>
</div>
<div class="row pt-4 pb-2 no-gutters">
  <div class="col-12 text-right">
    <button class="btn btn-primary border mr-1 btn-150" data-toggle="modal" data-target="#setupRouteDriver"
      data-backdrop="static" data-keyboard="false" (click)="onSetupRouteClick();">Setup Route
      <!-- &nbsp;<span><i class="fas fa-chevron-right"></i></span> -->
    </button>
    <button class="btn btn-primary border mr-1 btn-150">Update Route
      <!-- &nbsp;<span><i class="fas fa-chevron-right"></i></span> -->
    </button>
    <button class="btn btn-primary border btn-150" data-toggle="modal" data-target="#vehicleAlerts"
      data-backdrop="static" data-keyboard="false" (click)="onAlertsClick()">Alerts
      <!-- &nbsp;<span><i class="fas fa-chevron-right"></i></span> -->
    </button>
  </div>
</div>
<div class="row mb-1 no-gutters">
  <div class="col-9">
    <label  >Please select fleet location to view the routes</label>
  </div>
  <div class="col-3">
    <button class="btn btn-sm btn-outline-danger float-right" (click)="executeTelematicService();">Refresh
      Location</button>
  </div>
  <div class="col-12 col-sm-12 col-md-3 col-lg-3">
    <div class="card gmap">
      <select id="loc" class="w-100" (change)="onDashboardLocationChange($event.target.value)">
        <option value="-1">Select Location</option>
        <option *ngFor="let location of facilityList; let i = index;" value={{i}}>
          <span *ngIf="location.address.name">{{location.address.name}}</span>
          <span *ngIf="location.address.name == null || location.address.name == undefined">{{location.address.street}}, {{location.address.city}}</span>
        </option>
      </select>
      <!-- <div *ngIf="selectedLocation.address.name != 'Select Location' && (!driverDetailList || driverDetailList.length < 1)">
          <small class="text-danger text-center">No exisitng routes</small>
      </div> -->
      <div *ngIf="driverDetailList && driverDetailList.length > 0">
        <div *ngFor="let routeDriver of driverDetailList;">
          <div class="row no-gutters">
            <div class="col-3 text-center">
              <!-- <div class="p-2 align-middle" [style.backgroundColor]="routeDriver.color"></div> -->
              <button [style.backgroundColor]="routeDriver.color" class="btn btn-lg"></button>
            </div>
            <div class="col">
              <span>{{routeDriver.name}}</span><br>
              <small><span *ngIf="routeDriver"> {{routeDriver.make}}</span></small>/
              <small><span *ngIf="routeDriver">{{routeDriver.model}}</span></small>/
              <small><span *ngIf="routeDriver">{{routeDriver.year}}</span></small><br>
              <small><span *ngIf="routeDriver">{{routeDriver.vin}}</span></small>
            </div>
          </div>
          <hr>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-sm-12 col-md-9 col-lg-9">
    <div class="gmap" id="map_canvas" #gmap>.</div>
  </div>
</div>

<!-- Modal Setup Route Driver -->
<div class="modal fade" id="setupRouteDriver" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="setupRouteDriverTitle">Setup Route Driver</h5>
        <button type="button" (click)="resetSetupRouteDriverForm();" class="close" data-dismiss="modal"
          aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form name="setupDriver" (ngSubmit)="setupRouteDriverForm.form.valid" #setupRouteDriverForm="ngForm" novalidate>
        <div class="modal-body">
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label for="forDate"><span class="maroon  astrisk">&#10033;&nbsp;</span>Select Date</label><br>
                <p-calendar name="forDate" [minDate]="minimumCalanderDate" [(ngModel)]="setupRouteModal.date"
                  showTime="true" #forDate="ngModel" required></p-calendar>
                <small class="text-danger" *ngIf="forDate.invalid && (forDate.dirty || forDate.touched)">
                  <p class="mb-0" *ngIf="forDate.errors.required">*Required</p>
                </small>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="fleetLocation"><span class="maroon  astrisk">&#10033;&nbsp;</span>Select Fleet
                  Location</label><br>
                <select id="fleetLocation" name="fleetLocation" [(ngModel)]="setupRouteModal.fleetLocation"
                  #fleetLocation="ngModel" required (change)="onDriverSetupLocationChange()">
                  <option [ngValue]="null">Select Location</option>
                  <option *ngFor="let location of facilityList; let i = index;" [ngValue]="location">
                    <span *ngIf="location.address.name">{{location.address.name}}</span>
                    <span *ngIf="location.address.name == null || location.address.name == undefined">{{location.address.street}}, {{location.address.city}}</span>
                  </option>
                </select>
                <small class="text-danger"
                  *ngIf="fleetLocation.invalid && (fleetLocation.dirty || fleetLocation.touched)">
                  <p class="mb-0" *ngIf="fleetLocation.errors.required">*Required</p>
                </small>
                <!-- <small class="text-danger" *ngIf="fleetLocation.dirty || fleetLocation.touched">
                    <p class="mb-0" *ngIf="!vehiclesFound && (!fleetLocation.errors || !fleetLocation.errors.required)">*No vehicles found</p>
                </small> -->
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label for="driver"><span class="maroon  astrisk">&#10033;&nbsp;</span>Select Driver</label><br>
                <select id="driver" name="driver" [(ngModel)]="setupRouteModal.driver" #driver="ngModel" required>
                  <option [ngValue]="null">Select Driver</option>
                  <option *ngFor="let driver of driverList; let i = index;" [ngValue]="driver">
                    {{driver.name}}
                  </option>
                </select>
                <small class="text-danger" *ngIf="driver.invalid && (driver.dirty || driver.touched)">
                  <p class="mb-0" *ngIf="driver.errors.required">*Required</p>
                </small>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="selectVehicle"><span class="maroon  astrisk">&#10033;&nbsp;</span>Assign Vehicle</label><br>
                <select id="selectVehicle" name="selectVehicle" [(ngModel)]="setupRouteModal.vehicle"
                  #selectVehicle="ngModel" required>
                  <option [ngValue]="null">Select Vehicle</option>
                  <option *ngFor="let vehicle of vehicleList; let i = index;" [ngValue]="vehicle">
                    {{vehicle.make}}-{{vehicle.model}}-{{vehicle.vin}}
                  </option>
                </select>
                <small class="text-danger"
                  *ngIf="selectVehicle.invalid && (selectVehicle.dirty || selectVehicle.touched)">
                  <p class="mb-0" *ngIf="selectVehicle.errors.required">*Required</p>
                </small>
              </div>
            </div>
          </div>
          <div class="text-danger text-center mt-4">
             <small> <p class="mb-0" *ngIf="!vehiclesFound">*No vehicles avaiable at the selected location</p> </small>
          </div>
        </div>
      </form>
      
      <div class="modal-footer">
        <button type="button" class="btn btn-light btn-80" (click)="resetSetupRouteDriverForm();"
          data-dismiss="modal">CANCEL</button>
        <button type="button" class="btn btn-primary"
          [disabled]="setupRouteDriverForm.form.pristine || setupRouteDriverForm.form.invalid" data-dismiss="modal"
          (click)="onSetupRouteDriver()">SAVE &
          CONTINUE
          &nbsp;<span><i class="fas fa-chevron-right"></i></span>
        </button>
      </div>
    </div>
  </div>
</div>


<!-- Modal Setup Route Conditions -->
<button type="button" class="btn btn-primary" id="openSetupRouteCondition" [hidden]="true" data-toggle="modal"
  data-target="#setupRouteCondition" data-backdrop="static" data-keyboard="false" data-dismiss="modal">Hidden
  Btn</button>

<div class="modal fade" id="setupRouteCondition" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="setupRouteConditionTitle">Setup Route Conditions</h5>
        <button type="button" class="close" (click)="resetSetupRouteDriverForm();" data-dismiss="modal"
          aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form name="setupConditions" (ngSubmit)="setupRouteConditionForm.form.valid" #setupRouteConditionForm="ngForm"
        novalidate>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm">
              <label for="forDate"><span class="maroon  astrisk">&#10033;&nbsp;</span>Start Point</label>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-5">
              <div class="form-group">
                <input type="text" class="form-control" id="forDate" name="forDate" placeholder="Enter Address" required
                  [disabled]="true">
              </div>
            </div>
            <span class="ml-3">Or</span>
            <div class="col-sm-5 ml-3">
              <div class="form-group">
                <select id="startPointLocation" name="startPointLocation"
                  [(ngModel)]="setupRouteModal.startPoint.location" #startPointLocation="ngModel" required>
                  <option [ngValue]="null">Select Location</option>
                  <option *ngFor="let location of locations; let i = index;" [ngValue]="location">
                    <span *ngIf="location.address.name">{{location.address.name}}</span>
                    <span *ngIf="location.address.name == null || location.address.name == undefined">{{location.address.street}}, {{location.address.city}}</span>
                  </option>
                </select>
                <small class="text-danger"
                  *ngIf="startPointLocation.invalid && (startPointLocation.dirty || startPointLocation.touched)">
                  <p class="mb-0" *ngIf="startPointLocation.errors.required">*Required</p>
                </small>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <label for="forDate"><span class="maroon  astrisk">&#10033;&nbsp;</span>End Point</label>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-5">
              <div class="form-group">
                <input type="text" class="form-control" id="forDate" name="forDate" placeholder="Enter Address" required
                  [disabled]="true">
              </div>
            </div>
            <span class="ml-3">Or</span>
            <div class="col-sm-5 ml-3">
              <div class="form-group">
                <select id="endPointLocation" name="endPointLocation" [(ngModel)]="setupRouteModal.endPoint.location"
                  #endPointLocation="ngModel" required>
                  <option [ngValue]="null">Select Location</option>
                  <option *ngFor="let location of locations; let i = index;" [ngValue]="location">
                    <span *ngIf="location.address.name">{{location.address.name}}</span>
                    <span *ngIf="location.address.name == null || location.address.name == undefined">{{location.address.street}}, {{location.address.city}}</span>
                  </option>
                </select>
                <small class="text-danger"
                  *ngIf="endPointLocation.invalid && (endPointLocation.dirty || endPointLocation.touched)">
                  <p class="mb-0" *ngIf="endPointLocation.errors.required">*Required</p>
                </small>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="speedLimit">Route Speed Limit</label><br>
                <input type="text" class="form-control" id="speedLimit" name="speedLimit" placeholder="Enter MPH"
                  [(ngModel)]="setupRouteModal.speedLimit.value" #speedLimit="ngModel">
                <small class="text-danger" *ngIf="speedLimit.invalid && (speedLimit.dirty || speedLimit.touched)">
                  <p class="mb-0" *ngIf="speedLimit.errors.required">*Required</p>
                </small>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <label for="forDate">Set Curfew</label>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-5">
              <div class="form-group">
                <p-calendar name="curfewStartTime" [minDate]="minimumCalanderDate"
                  [(ngModel)]="setupRouteModal.curfew.startTime" (onSelect)="onCurfewStartTimeSelected();"
                  [showTime]="true" #curfewStartTime="ngModel" required>
                </p-calendar>
                <small class="text-danger"
                  *ngIf="curfewStartTime.invalid && (curfewStartTime.dirty || curfewStartTime.touched)">
                  <p class="mb-0" *ngIf="curfewStartTime.errors.required">*Required</p>
                </small>
              </div>
            </div>
            <span class="ml-3" [hidden]="true">Or</span>
            <div class="col-sm-4 ml-5">
              <div class="form-group">
                <p-calendar name="curfewEndTime" [minDate]="minimumCalanderDate"
                  [(ngModel)]="setupRouteModal.curfew.endTime" [showTime]="true" #curfewEndTime="ngModel" required>
                </p-calendar>
                <small class="text-danger"
                  *ngIf="curfewEndTime.invalid && (curfewEndTime.dirty || curfewEndTime.touched)">
                  <p class="mb-0" *ngIf="curfewEndTime.errors.required">*Required</p>
                </small>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="modal-footer">
        <button type="button" class="btn btn-light btn-80" data-dismiss="modal"
          (click)="resetSetupRouteDriverForm();">CANCEL</button>
        <button type="button" class="btn btn-primary"
          [disabled]="setupRouteConditionForm.form.pristine || setupRouteConditionForm.form.invalid"
          data-dismiss="modal" (click)="onSetupRouteConditions()">SAVE &
          CONTINUE
          &nbsp;<span><i class="fas fa-chevron-right"></i></span>
        </button>
      </div>
    </div>
  </div>
</div>


<!-- Modal Setup Route Stops -->

<button type="button" class="btn btn-primary" id="openSetupRouteStops" [hidden]="true" data-toggle="modal"
  data-target="#setupRouteStops" data-backdrop="static" data-keyboard="false" data-dismiss="modal">Hidden
  Btn</button>

<div class="modal fade" id="setupRouteStops" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="setupRouteDriverTitle">Setup Route Stops</h5>
        <button type="button" (click)="resetSetupRouteDriverForm();" class="close" data-dismiss="modal"
          aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form name="setupRouteStops" (ngSubmit)="setupRouteStopsForm.form.valid" #setupRouteStopsForm="ngForm" novalidate>
        <div class="modal-body">
          <div class="form-group">
            <label for="vin">Add Stops</label>
            <div class="row">
              <div class="col-5">
                <label for="vin">Stop</label>
              </div>
              <div class="col-3">
                <label for="vin">ETA</label>
              </div>
              <div class="col">
                <button type="button" class="btn btn-light pt-0 pb-0 float-right" (click)="addStop()"><small><i
                      class="fas fa-plus maroon"></i>
                    Add Stop</small></button>
              </div>
            </div>

            <div class="row mt-2" *ngFor="let stop of setupRouteModal.stops; let i=index;">
              <div class="col-5">
                <select id="startPointLocation" (change)="onStopLocationChange($event.target.value, i)">
                  <option value="0">Select Location</option>
                  <option *ngFor="let location of locations; let j = index;" value={{j}}>
                    <span *ngIf="location.address.name">{{location.address.name}}</span>
                    <span *ngIf="location.address.name == null || location.address.name == undefined">{{location.address.street}}, {{location.address.city}}</span>
                  </option>
                </select>
              </div>
              <div class="col-5">
                <p-calendar name="estimatedArrivalTime{i}" [minDate]="minimumCalanderDate"
                  [(ngModel)]="stop.estimatedArrivalTime" [showTime]="true">
                </p-calendar>
              </div>
              <div class="col">
                <small><i class="fas fa-times maroon pointer" data-toggle="tooltip" data-placement="right"
                    title="Remove" (click)="removeRoute(i)"></i></small>
              </div>
            </div>

          </div>
        </div>
      </form>
      <div class="modal-footer">
        <button type="button" class="btn btn-light btn-80" (click)="resetSetupRouteDriverForm();"
          data-dismiss="modal">CANCEL</button>
        <button type="button" class="btn btn-primary btn-80" data-dismiss="modal" (click)="onSetupRoutes()">DONE</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Alerts -->
<div class="modal fade" id="vehicleAlerts" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="setupRouteDriverTitle">Alerts</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <!-- <div class="row">
          <div class="col-5">Time<small></small></div>
          <div class="col-3">Alert Type<small></small></div>
          <div class="col-4">Description<small></small></div>
        </div>
        <div *ngIf="alertData.length > 0">
          <div class="row" *ngFor="let alert of alertData;">
            <div class="col-5"><small>{{alert.timeStamp | date:'MMM d, y h:mm:ss a'}}</small></div>
            <div class="col-3"><small>{{alert.type}}</small></div>
            <div class="col-4"><small>{{alert.transitionType}}</small></div>
          </div>
        </div>
        <div *ngIf="alertData == null || alertData.length == 0" class="row text-center mt-3">
          <div class="col text-center">
            <h3 class="text-muted">No Alerts</h3>
          </div>
        </div> -->

        <table class="table table-striped">
          <thead class="thead-light">
            <tr>
              <th scope="col">Time</th>
              <th scope="col">Alert Type</th>
              <th scope="col" class="text-center">Description</th>
            </tr>
          </thead>
          <tbody *ngIf="alertData.length > 0">
            <tr class="cursor-pointer" *ngFor="let alert of alertData;" (click)="packageClickedForView(package)">
              <td>{{alert.timeStamp | date:'MMM d, y h:mm:ss a'}}</td>
              <td>{{alert.type}}</td>
              <td>{{alert.transitionType}}</td>
            </tr>
          </tbody>
        </table>

        <div *ngIf="alertData == null || alertData.length == 0" class="row text-center mt-4">
          <div class="col text-center">
            <h5 class="text-muted">No Alerts</h5>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>